import { UrlConfigModel } from '@models/shared/shared-models';

export const apiUrlStore: UrlConfigModel[] = [
    {
        alias: '@careApi',
        artifactName: 'Euclid.WebApi.PatientCare',
        relativeUrl: "/api",
        scopes: [ "patient_care_jwt" ]
    }
];